import React from 'react';
// import MainSearch from '../../components/MainSearch/MainSearch';
// import SliderPromo from '../../components/SliderPromo/SliderPromo';
import OfertasDestacadas from '../../components/OfertasDestacadas/OfertasDestacadas';
import Services from '../../components/Services/Services';
// import { Promos } from '../../components/Promos/Promos';
import CarouselHome from '../../components/Carousel/Carousel';


const Home = () => {
  return (
    <>
      <CarouselHome />
      <OfertasDestacadas />
      {/* <MainSearch /> */}
      {/* <Promos /> */}
      {/* <SliderPromo /> */}
      <Services />
    </>
  );
};

export default Home;
